const getRecentHealthData = (state) => {
  return (
    state.healthData.length > 0 && state.healthData[state.healthData.length - 1]
  );
};

export { getRecentHealthData };
